var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThe217LogoTransparentNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 320 80",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Project 217 \u2014 UIAA Staff Portal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 6) scale(0.62)",
    fill: "none",
    stroke: "#FF5F05",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 112,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 100,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 10,
    height: 88,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 104,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 10,
    height: 88,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 104,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 16,
    width: 10,
    height: 88,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 14,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 104,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 16,
    width: 10,
    height: 88,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 14,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 104,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,104 L36,52 Q36,16 56,16 Q76,16 76,52 L76,104"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 109,
    width: 112,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 116,
    width: 120,
    height: 5,
    rx: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 30,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "rgba(255,255,255,0.4)",
    letterSpacing: 3
  }, "PROJECT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 68,
    fontFamily: "Arial Black, Arial, sans-serif",
    fontSize: 46,
    fontWeight: 900,
    fill: "white",
    letterSpacing: -1
  }, "217")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThe217LogoTransparentNew);
export default __webpack_public_path__ + "static/media/the217_logo_transparent-new.08cae56f012758d7c07eb95cfa096809.svg";
export { ForwardRef as ReactComponent };